const getPageContext = (contextPath: string) => {
  switch (contextPath) {
    case "empresa":
      return "Empresa";
    case "servicos":
      return "Serviços";
    case "contato":
      return "Contato";
    case "formulario-lgpd":
      return "Formulário para Requisição do Titular de Dados Pessoais - LGPD";
    default:
      return "";
  }
}
export { getPageContext };
